import { HorizontalNav } from '@trufla-technology/trumarket-react-design-system';
import './style.scss';
import { CompanyBranches } from './CompanyBranches';
import { BranchForm } from './BranchForm/index';
import { EditBranch } from './EditBranch/index';
import { CompanyDetailsForm } from './CompanyDetailsForm/index';

import { Route } from 'react-router-dom';
import { useAuthContext } from '@trufla-technology/trufla-trudomain/dist/lib';
import { TruRoute } from '../../../TruRoute';

export type SearchObject = {
  searchValue: string;
};

export const CompanyDetails = () => {
  const { isPermitted } = useAuthContext();
  return (
    <div className="company-details-page">
      <div className="company-details-client-tabs-wrapper">
        <HorizontalNav
          selected={false}
          active="/company"
          tabs={[
            { label: 'Company', path: '/company' },
            isPermitted('listLocations')
              ? { label: 'Branches', path: '/branches' }
              : { label: '' },
          ]}
        >
          <div className="company-details">
            <CompanyDetailsForm />{' '}
          </div>
          <div className="company-branches">
            <Route
              exact
              path="/configurations/company-details/"
              component={CompanyBranches}
            />
            <TruRoute
              path="/configurations/company-details/create-branch"
              component={BranchForm}
              permission={['createLocation']}
            />
            <Route
              exact
              path="/configurations/company-details/edit/:key"
              component={EditBranch}
            />
          </div>
        </HorizontalNav>
      </div>
    </div>
  );
};
